export default __webpack_public_path__ + "static/clustering-167826b1e91cd9f039d46ac27290de9f.png";